import { configureStore } from "@reduxjs/toolkit";
import accessLLMModelsSlice from "./redux/accessLLMModelsSlice";
import activeWorkspaceSlice from "./redux/activeWorkspaceSlice";
import aiGeneratedMessageSlice from "./redux/aiGeneratedMessage";
import announcementsSlice from "./redux/announcementsSlice";
import citationsSlice from "./redux/citationsSlice";
import currentConversationSetter from "./redux/conversations";
import currentAttachments from "./redux/currentAttachments";
import currentUserSlice from "./redux/currentUser";
import diagnosticsSlice from "./redux/diagnosticsSlice";
import diagnosticChatSlice from "./redux/diagnosticChatSlice";
import projectIqWorkspacesSlice from "./redux/projectIqWorkspacesSlice";
import currentFilesSlice from "./redux/files";
import currentLLMConfigSlice from "./redux/llmConfig";
import currentMessagesSetter from "./redux/messages";
import referencedConversationsSlice from "./redux/referencedConversationsSlice";
import currentPromptSlice from "./redux/selectedPrompt";
import currentTagsSlice from "./redux/tags";
import temporaryChatSlice from "./redux/temporaryChat";
import toastSlice from "./redux/toastSlice";
import useCasesSlice from "./redux/useCasesSlice";
import useCasePromptsSlice from "./redux/useCasePromptsSlice";
import usersSlice from "./redux/users";
import workspaceLibraryDocumentsSlice from "./redux/workspaceLibraryDocuments";
import workspacesSlice from "./redux/workspacesSlice";

const store = configureStore({
  reducer: {
    currentConversationSetter,
    currentMessagesSetter,
    aiGeneratedMessageSlice,
    currentTagsSlice,
    currentLLMConfigSlice,
    currentPromptSlice,
    currentFilesSlice,
    currentUserSlice,
    currentAttachments,
    usersSlice,
    temporaryChatSlice,
    announcementsSlice,
    citationsSlice,
    accessLLMModelsSlice,
    useCasesSlice,
    useCasePromptsSlice,
    workspacesSlice,
    activeWorkspaceSlice,
    referencedConversationsSlice,
    diagnosticsSlice,
    diagnosticChatSlice,
    projectIqWorkspacesSlice,
    toastSlice,
    workspaceLibraryDocumentsSlice,
  },
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
